import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections';
import type { Dispatch, SetStateAction } from 'react';
import { useMemo } from 'react';
import type { AudienceListType, FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types';
import { buildFullSegmentTree } from '../../../utils/buildFullSegmentTree';
import { CongressionalDistrictPicker } from './CongressionalDistrictPicker/CongressionalDistrictPicker';
import { CongressionalDistrictsTreeList } from './CongressionalDistrictsTreeList';
import { createSegmentDeleteHandler } from './utils/createSegmentDeleteHandler';

export type LocationCongressionalProps = {
  isEdit: boolean;
  listType: AudienceListType;
  locationCongressionalSegments: FormSegment[];
  setLocationCongressionalSegments: Dispatch<SetStateAction<FormSegment[]>>;
  options: FormSegment[];
};

export const LocationCongressional = ({
  isEdit,
  listType,
  locationCongressionalSegments,
  setLocationCongressionalSegments,
  options,
}: LocationCongressionalProps) => {
  const congressionalDistrictSegments = useMemo(() => buildFullSegmentTree(options), [options]);

  return (
    <IndentedSections>
      {isEdit && (
        <CongressionalDistrictPicker
          data={congressionalDistrictSegments}
          value={locationCongressionalSegments}
          onChange={setLocationCongressionalSegments}
        />
      )}

      {locationCongressionalSegments.length > 0 && (
        <CongressionalDistrictsTreeList
          listType={listType}
          locationSegments={locationCongressionalSegments}
          allSegments={congressionalDistrictSegments}
          onSegmentDelete={createSegmentDeleteHandler(locationCongressionalSegments, setLocationCongressionalSegments)}
        />
      )}
    </IndentedSections>
  );
};
